import { parseISO, format } from "date-fns";

export default function (date) {
  date = parseISO(date);

  let str = format(date, `do MMM yy`);

  return str;
}
